export default "__VITE_ASSET__BZZ8Ku33__"